'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isValid = require('./isValid');

var _isValid2 = _interopRequireDefault(_isValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

exports.default = createIsInvalid;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/selectors/isInvalid.js
 ** module id = 1427
 ** module chunks = 0
 **/